import { FormGroup as MuiFormGroup } from '@material-ui/core'
import styled from 'styled-components'

import { DispensaryContactCard } from '../../../../../dispensaries/contact-card/DispensaryContactCard'
import Link from '../../../../../global/Link'

export const Abstract = styled.div`
  p:last-child {
    margin-bottom: 0;
  }
`

export const HeaderButtonAndAbstract = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 20px;
  grid-template-rows: auto;
  grid-template-areas: 'header' 'abstract' 'button';
  column-gap: 15px;
  row-gap: 20px;

  h3 {
    grid-area: header;
    margin-bottom: 0;
  }

  button {
    grid-area: button;
  }

  ${Abstract} {
    grid-area: abstract;
  }

  @media (min-width: 450px) {
    grid-template-columns: auto 1fr auto;
    grid-template-areas: 'header . button' 'abstract abstract abstract';
    align-items: center;
    justify-content: space-between;
    h3 {
      margin-bottom: 0;
    }
  }
  @media print {
    button {
      display: none;
    }
  }
`

export const TrailingButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 4rem;
  @media (min-width: 450px) {
    align-items: flex-end;
  }
  @media print {
    button {
      display: none;
    }
  }
`

export const FormDiv = styled.div`
  max-width: 350px;
`

export const Heading = styled.h4`
  margin-top: 30px;
  margin-bottom: 15px;
`

export const FormGroup = styled(MuiFormGroup)`
  max-width: 500px;
  align-items: end;
`

export const SwitchText = styled.p`
  font-size: 16px;
  margin: 0;
`

export const SwitchSubText = styled.p`
  font-size: 12px;
  margin: 0;
`

export const SwitchSubTextLink = styled(Link)`
  color: ${({ theme }) => theme.colors.brand.red};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const DispensaryContactCardPrime = styled(DispensaryContactCard)`
  // add border to distinguish card from page background
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool450};
`
